import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

export const useResendInvite = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ leagueId, userEmail }) => {
      const apiUrl = process.env.REACT_APP_API_URL;
      const token = await getAccessTokenSilently();

      const response = await axios.post(
        `${apiUrl}/api/league/resend-invite`,
        { leagueId, userEmail },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("leagueDetails");
      },
    },
  );
};
